import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { companyRealtorModels } from '..';

export function useCompanyRealtorBanalce(realtorId: number) {
  return useQuery<companyRealtorModels.ICompanyBalance[]>({
    queryKey: ['company-realtor-balance', realtorId],
    queryFn: async () => {
      const res = await $api.get(`/v1/company/realtor/company-balance?realtorId=${realtorId}`);

      return res.data.data;
    },
    enabled: !!realtorId,
    refetchOnWindowFocus: false,
    retry: false
  });
}
